module.exports = __webpack_public_path__ + "img/navigation-bar.a05ab04a.png";